import {useTranslation} from 'react-i18next';

import {Box, Typography} from '@mui/material';

import {EmpionButton} from '../../../components/EmpionButton/EmpionButton';
import {getLogo} from '../../../layouts/theme/Utils';
import {AppConfig} from '../../../lib/AppConfig';

export default function OnboardingCompleted() {
  const {t} = useTranslation();

  return (
    <Box
      display={'flex'}
      flexDirection={'column'}
      alignItems={'center'}
      sx={{
        mt: 5,
        backgroundColor: 'background.menu',
        borderRadius: 3,
        p: 4,
      }}
      gap={2}
    >
      <Box
        display={'flex'}
        sx={{
          justifyContent: {xs: 'center', md: 'left'},
        }}
      >
        <Box component={'img'} src={getLogo()} alt='Empion Logo' />
      </Box>

      <Typography variant='h1' textAlign={'center'}>
        {t('applicantOnboarding.complete.title')}
      </Typography>

      <Typography mb={1} variant='h3' textAlign={'center'}>
        {t('applicantOnboarding.complete.subTitle')}
      </Typography>
      <EmpionButton href={AppConfig.PROFILE_PATH} sx={{textAlign: 'center'}}>
        {t('applicantOnboarding.complete.backToMyProfile')}
      </EmpionButton>
    </Box>
  );
}
